// src/RequireAuth.js

import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { isUserAuthenticated } from './utils/authSession';

const RequireAuth = () => {
  const isAuthenticated = isUserAuthenticated();
  const location = useLocation();
  const requiresPayment = localStorage.getItem('requiresPayment') === 'true';
  const role = String(localStorage.getItem('role') || '').toUpperCase();
  const isPlatformAdmin = ['SUPER_ADMIN', 'APP_ADMIN', 'SYSTEM_ADMIN'].includes(role);
  const billingPath = '/subscription/payments';

  if (!isAuthenticated) {
    // Redirect to login page with the return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isPlatformAdmin && requiresPayment && location.pathname !== billingPath) {
    return <Navigate to={billingPath} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
